import { createAsyncMiddleware } from 'redux-easy-async';
import { NWJS_FACTORY_REDUX_ASYNC_MIDDLEWARE_TYPE } from './utils';
export default (function () {
  var requestOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (!requestOptions.FactorySDK) {
    throw new Error('FactorySDK is required');
  }

  return createAsyncMiddleware({
    namespace: NWJS_FACTORY_REDUX_ASYNC_MIDDLEWARE_TYPE,
    requestOptions: requestOptions
  });
});